import {createApp} from "vue";
import ElementPlus from "element-plus";
import VueMarkdownEditor from "@kangc/v-md-editor";
import "@kangc/v-md-editor/lib/style/base-editor.css";
import vuepressTheme from "@kangc/v-md-editor/lib/theme/vuepress.js";
import "@kangc/v-md-editor/lib/theme/style/vuepress.css";
import "element-plus/dist/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import Prism from "prismjs";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import CKEditor from '@ckeditor/ckeditor5-vue';

const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
};

VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});

createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, {locale: zhCn})
  .use(VueMarkdownEditor)
  .use(Antd)
  .use(CKEditor)
  .mount("#app");
